module.exports = __webpack_public_path__ + "img/topo-historia-e-geografia.7fd2d01f.png";